import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["validationError"]
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 1,
  class: "validation-container"
}
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", {
    validationError: (_ctx.errors.length > 0 || _ctx.error.length > 0 || _ctx.hasError),
    class: _normalizeClass({'disabled': _ctx.disabled})
  }, [
    (!!_ctx.$slots.header)
      ? (_openBlock(), _createElementBlock("header", _hoisted_2, [
          _renderSlot(_ctx.$slots, "header", {}, undefined, true)
        ]))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "default", {}, undefined, true),
    ((_ctx.errors.length > 0 || _ctx.error.length > 0) && _ctx.showMessage)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors, (error, index) => {
            return (_openBlock(), _createElementBlock("li", {
              key: index,
              innerHTML: error.$message
            }, null, 8, _hoisted_4))
          }), 128)),
          (_ctx.error)
            ? (_openBlock(), _createElementBlock("li", _hoisted_5, _toDisplayString(_ctx.error), 1))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 10, _hoisted_1))
}